import React, {useState, useEffect, useRef} from 'react'
import propTypes from 'prop-types'
import {Grid, Box} from '@mui/material';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material/styles';import { useMediaQuery } from '@mui/material';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import {ReactSVG} from 'react-svg';
import {sortBy, uniqBy, findIndex, get} from 'lodash';
import {gql} from '@apollo/client';
import qs from 'qs';

import jaycoClient from '../../../graphql/stockClient';
import withWidth from '../../../components/hoc/withWidth';
import {theme} from '../../../themes/default-theme';
import StockFilter from '../../StockFilter';
import filter from '../../../assets/icons/filter.svg';
import close from '../../../assets/icons/close.svg';
import Cta from '../../../components/ui/Cta';
import Icon from '../../../components/ui/Icon';
import StockCard from '../../../components/navigation/StockCard';
import Dropdown from '../../../components/ui/Dropdown';
import Text from '../../../components/typography';
import Pagination from '../../../components/navigation/Pagination';
import toPrice from '../../../util/toPrice';
import StockItem from '../../StockItem';
import Loader from '../../../components/ui/Loader';
import getUrlParams from '../../../util/getUrlParams'
import dlPush from '../../../util/dlPush';
import repaymentCalc from '../../../util/repaymentCalc';
import ContentBuilder from '../../ContentBuilder';
import Breadcrumbs from '../../../components/navigation/NewBreadcrumbs';
import topoPng from '../../../assets/topo-grey.png';

const customTheme = createTheme({
  overrides: {
    MuiDrawer: {
      paper: {
        width: '100%',
        backgroundColor: theme.palette.white
      }
    },
    MuiBackdrop: {
      root: {
        display: 'none',
      }
    }
  }
});


const GridItem = styled(Grid)`
  
`

const Topo = styled.div`
    display: block;
    top: 0;
    left: 0;
    z-index: 1;
    overflow: hidden;
    background-image: url(${topoPng});
    background-position: center;
    width: 100%;
    background-size: 100% auto;
    margin-bottom: 30px;

    ${theme.breakpoints.up("md")} {
      margin-bottom: 45px;
    }
`

const BreadcrumbsContainer = styled.div`
  margin-bottom: 20px;
  position: relative;
  margin-top: 20px;

  ${props => props.margin === 1 && `
    margin-top: 30px;
  `}

  ${theme.breakpoints.down('sm')} {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`

const Wrapper = styled.div`
  ${props => props.bg && `
    background-color: #F3F4F7;
  `}

`

const GreyWrapper = styled.div`
  position: relative;
`

const GreyBg = styled.div`

  padding-top: 40px;

  ${theme.breakpoints.up('lg')} {
    padding-top: 0;
  }
`

const GreyTop = styled.div`
  ${theme.breakpoints.up('lg')} {
    height: 50px;
    width: 100%;
    display: block;
    border-radius: 0 50px 0 0;
    background: #F3F4F7;
    transform: rotate(-1deg);
    position: absolute;
    top: -30px;
    z-index: -1;
  }
`

const FilterContainer = styled.div`
  padding-bottom: 70px;
`

const CloseContainer = styled.div`
  text-align: center;
  padding: 7px;
  width: 100%;
  background-color: ${theme.palette.white};

  position: fixed;
  z-index: 99;
`

const Filters = styled.div`
  overflow-x: hidden;
  padding-top: 60px;
  padding-bottom: 30px;
  max-width: 480px;
  margin: 0 auto;

  ${theme.breakpoints.up('lg')} {
    padding-top: 30px;
  }
`

const FilterBtn = styled(props => {
  return <Cta {...props} />
})`
  display: block;
  margin: 0 auto;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 1.71px;
  line-height: 24px;
  max-width: 270px;

  svg {
    width: 20px;
    height: 20px;
    display: block;
    position: absolute;
    top: 12px;
    left: 30px;
  }

  span {
    padding-left: 34px;
  }
`
const CaravanCardWrapper = styled(Box)`
  height: 100%;
`

const CaravanCardContainer = styled.div`
  margin: 0 auto 20px;
  height: 100%;
`

const Display = styled.div`
  ${theme.breakpoints.up('md')} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row-reverse;
  }
`

const DisplayItems = styled.div`

  margin-top: 15px;

  ${theme.breakpoints.up('md')} {
    margin-top: 0
  }
  
`

const DisplayDropdown = styled.div`
  width: 100%;
  max-width: 270px;
  margin: 0 auto;

  ${theme.breakpoints.up('sm')} {
    min-width: 305px;
    max-width: 100%;
    width: auto;
    margin: 0;
  }
`

const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;

  button[disabled],
  button[disabled].MuiPaginationItem-root {
    opacity: 0.5 !important;
  }
`

const TitleContainer = styled.div`
  margin-bottom: 18px;

  h1 {
    text-align: center;
  }

  ${theme.breakpoints.up('lg')} {

    h1 {
      text-align: left;
    }
  }
`

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;

  button {
    min-width: 45%;
  }
`
const LeftPadding = styled.div`
  ${theme.breakpoints.up('lg')} {
      padding-left: 30px;
      padding-right: 30px;
  }
`

  // FIX: windowData Twig script injection — keep as-is, this is fine since it uses
  // dangerouslySetInnerHTML which bypasses React's hydration diffing for that node
  // const windowData = `
  //   {{# if data.template.pageTitle}}
  //     <script>
  //         window.staticly.data.pageTitle = "{{data.template.pageTitle}}"
  //     </script>
  //   {{/if}}

  //   {{# if data.template.stockFilters}}
  //     <script>
  //         window.staticly.data.displayFinancePrice = "{{data.template.stockFilters.displayFinancePrice}}"
  //     </script>
  //   {{/if}}

  //   {{# if data.template.stockFilters.sort}}
  //     <script>
  //         window.staticly.data.sort = "{{data.template.stockFilters.sort}}"
  //     </script>
  //   {{/if}}
  // `

const StockContainer = (props) => {

  // FIX: Don't read from window at render time — causes hydration mismatch (React error 418)
  // All window/staticly access must live inside useEffect
  const [activeModel, setActiveModel] = useState(get(props, 'router.query.model', null));
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [defaultPageTitle, setDefaultPageTitle] = useState(null);

  const [filterDefaults, setFilterDefaults] = useState();
  const [dealerData, setDealerData] = useState(false);
  const [displayFinancePrice, setDisplayFinancePrice] = useState(true);

  // FIX: Use props.meta.title as the SSR-safe default — never branch on window during render
  const [title, setTitle] = useState(props.meta.title);

  const between = (x, min, max) => {
    return x >= min && x <= max;
  }

  const getYear = (date) => {
    const s = date.toString();
    return s.substr(s.length - 4);
  }

  const refactorUbsData = (data) => {
    return data.map((item, index) => {
      const images = item.images.split(',');
      const image = images[0]


      const price = item.driveAwayPrice ? item.driveAwayPrice : item.askingPrice

      return {
        ...item,
        brand: item.make || null,
        category: item.variant,
        year: getYear(item.buildDate),
        id: item.id,
        type: item.type,
        name: item.model,
        price: price ? price : 0,
        showCharges: !item.driveAwayPrice && item.askingPrice,
        images,
        image,
        weeklyRepayment: (price && price.toString() !== '0') ? parseInt(repaymentCalc(props.rates, 52, price)) : null,
        cta: {
          text: "Find out more",
          url: `/stock?model=${item.id}`
        }
      }
    })

  }

  const getStockFilterData = () => {

    const categories = uniqBy(allStock.map((item) => { return {value: item.category, text: item.category}}), 'value');

    let types = [];
    let brands = [];
    let models = [];
    let minPrice = 0;
    let maxPrice = 0;
    let minYear = null;
    let maxYear = null;

    allStock.forEach((item, index) => {

      const typeIndex = findIndex(types, {value: item.type})
      if (typeIndex === -1) {
        types.push({value: item.type, text: item.type})
      }

      const brandIndex = findIndex(brands, {value: item.brand})
      if (brandIndex === -1) {
        brands.push({value: item.brand, text: item.brand, models: []})
      }
      
      const bIndex = brandIndex === -1 ? (brands.length - 1) : brandIndex;
      const modelIndex = findIndex(models, {value: item.name});

      if (modelIndex === -1) {
        models.push({value: item.name, text: item.name, checked: true});
      }

      const price = parseInt(item.price);

      if (index === 0) {
        minPrice = price;
        maxPrice = price;
      }

      if (price > maxPrice) {
        maxPrice = price;
      }

      if (price < minPrice) {   
        minPrice = price;
      }

      const year = parseInt(item.year)
      if (!minYear || year < minYear) {
        minYear = year
      }
      if (!maxYear || year > maxYear) {
        maxYear = year
      }

      const brandModelIndex = findIndex(brands[bIndex].models, {value: item.name});
      if (brandModelIndex === -1) {
        brands[bIndex].models.push({value: item.name, text: item.name});
      }
    });

    const filterMaxPrice = maxPrice > 320000 ? maxPrice : 320000

    let stockFilter = {
      types: [{value: 'all', text: 'All'}, ...types],
      categories: [{value: 'all', text: 'All'}, ...categories],
      brands: [{value: 'all', text: 'All'}, ...brands],
      models,
      price: {min: minPrice, max: filterMaxPrice},
      year: {min: minYear, max: maxYear},
      key: Date.now()
    }

    console.log('stockFilter', JSON.stringify(stockFilter))

    const qsData = qs.parse(window.location.search.replace('?',''));

    if (qsData && qsData.search && qsData.search.type) {
      stockFilter = {
        ...stockFilter,
        types: stockFilter.types.map(item => {
          return {
            ...item,
            checked: item.value.toLowerCase() === qsData.search.type.toLowerCase() ? true : false
          }
        })
      }
    }

    if (qsData && qsData.search && qsData.search.series) {
      stockFilter = {
        ...stockFilter,
        models: stockFilter.models.map(item => {
          return {
            ...item,
            checked: item.value.toLowerCase() === qsData.search.series.toLowerCase() ? true : false
          }
        })
      }
    }

    return stockFilter;
  }
  
  const numberPerPage = 15;
  const [drawer, setDrawer] = useState(false);
  const [sortByVal, setSortByVal] = useState({value: 'low'});
  const [stockItems, setStockItems] = useState([]);
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(numberPerPage);
  const [stockFilterState, setStockFilterState] = useState(null);
  const [allStock, setAllStock] = useState([]);
  const [defaultFilters, setDefaultFilters] = useState({});
  const [stockFilterData, setStockFilterData] = useState(null);
  
  // Keep track of checked filter types for mobile
  const [checkedTypes, setCheckedTypes] = useState({});

  useEffect(() => {
    const filterData = getStockFilterData();
    setStockFilterData(filterData);
    setDefaultFilters(filterData);
  }, [allStock]);

  useEffect(() => {
    handlePaginationChange(null, 1, false);
  }, [stockItems])

  useEffect(() => {
    // FIX: All window access safely inside useEffect — runs client-side only after hydration
    setDefaultPageTitle(document.title);

    // FIX: Read url params client-side only
    const activeModelParam = getUrlParams().model;
    if (activeModelParam) {
      setActiveModel(activeModelParam);
    }

    // FIX: Read window.staticly safely here, not at render time
    if (window.staticly?.data?.pageTitle) {
      setTitle(window.staticly.data.pageTitle);
    }

    const getData = async (dealerId) => {
      setLoading(true);
      
      const GET_UBS_DATA = gql`
        query GetUBSStockForDealer {
          getDealer(id: "${dealerId}") {
            name
            ubsStock(limit: 1000) {
              items {
                accessoryCodeList
                accessoryDescList
                askingPrice
                body
                branchId
                buildDate
                class
                colour
                complianceDate
                createdAt
                cylinders
                driveAwayPrice
                fuelType
                gearbox
                id
                make
                model
                odometer
                redbookCode
                regoExpiryDate
                regoNumber
                regoState
                seats
                series
                stockNumber
                tare
                trans
                trimColour
                type
                updatedAt
                variant
                vehicleDescription
                images
                vin
              }
            }
          }
        }
      `

      const result = (await jaycoClient.query({
        query: GET_UBS_DATA
      })) || {};

      const stock = get(result, 'data.getDealer.ubsStock.items', null)
      const data = stock ? refactorUbsData(stock) : null

      if (data) {
        setAllStock(data);
      }
      setError(null);
      setLoading(false);

      const activeModelParam = getUrlParams().model;
      if (activeModelParam){
        setModelTitle(data);
      } 
    }

    // FIX: window.staticly access moved inside useEffect — safe from hydration issues
    // Also guard against staticly not being defined yet
    const windowDealerId = (
      process.env.DEALER_SITE &&
      window.staticly?.dealerData?.id &&
      window.staticly.dealerData.id.indexOf('{{') === -1
    ) ? window.staticly.dealerData.id : null;

    const dealerId = windowDealerId ? windowDealerId : get(props, 'router.query.dealerid', null);

    getData(dealerId);

  }, []);

  // This useEffect runs after the component is mounted to properly initialize filters
  useEffect(() => {
    // Initialize filters and stock based on URL parameters (if any)
    if (allStock && allStock.length > 0) {
      const qsData = qs.parse(window.location.search.replace('?',''));
      
      // If URL has a type parameter, create and apply filters properly
      if (qsData && qsData.search && qsData.search.type) {
        console.log("Applying filter from URL parameter:", qsData.search.type);
        
        // Create a properly structured filter state
        const filterState = {
          types: { 
            vals: [{value: 'all', text: 'All', checked: false}].concat(
              Array.from(new Set(allStock.map(item => item.type)))
                .map(type => ({
                  value: type,
                  text: type,
                  checked: type.toLowerCase() === qsData.search.type.toLowerCase()
                }))
            )
          },
          categories: { 
            vals: [{value: 'all', text: 'All', checked: true}].concat(
              Array.from(new Set(allStock.map(item => item.category)))
                .filter(Boolean)
                .map(cat => ({
                  value: cat,
                  text: cat,
                  checked: true
                }))
            )
          },
          brands: { 
            vals: [{value: 'all', text: 'All', checked: true}].concat(
              Array.from(new Set(allStock.map(item => item.brand)))
                .filter(Boolean)
                .map(brand => ({
                  value: brand,
                  text: brand,
                  checked: true
                }))
            )
          },
          models: allStock
            .map(item => ({
              value: item.name,
              text: item.name,
              checked: true
            })),
          year: { 
            val: [
              Math.min(...allStock.map(item => parseInt(item.year) || 2000)),
              Math.max(...allStock.map(item => parseInt(item.year) || 2025))
            ]
          },
          price: {
            val: [
              Math.min(...allStock.map(item => parseInt(item.price) || 0)),
              Math.max(...allStock.map(item => parseInt(item.price) || 500000))
            ]
          }
        };
        
        // Update state with the properly constructed filter
        setStockFilterState(filterState);
        
        // Apply the filter directly
        handleUpdate(filterState);
      } else {
        // No URL filter, sort all stock normally
        sortItems(allStock);
      }
    }
  }, [allStock]);


  const sortItems = (data) => {
    var items;

    const stock = data || stockItems
    
    const stockArr = (sortByVal && sortByVal.value && sortByVal.value === 'low') ? [
      ...sortBy(stock.filter(item => item.price && item.price > 0), ['price']),
      ...sortBy(stock.filter(item => !item.price || item.price === 0), ['price'])
    ] : stock

    if(!sortByVal) {
      items = sortBy(stock, ['name']);
    } else {
      switch(sortByVal.value) {
        case 'low':
          items = stockArr
          break;
        case 'high':
          items = sortBy(stock, ['price']).reverse();
          break;
        default:
          items = sortBy(stock, ['name']);
      }
    }

    setStockItems(items.map(item => {
      const price = item.driveAwayPrice ? item.driveAwayPrice : item.askingPrice

      return {
        ...item,
            price: price ? price : 0,
            showCharges: !item.driveAwayPrice && item.askingPrice,
      }
    }));
  }

  useEffect(() => {
    sortItems()
  }, [sortByVal])

  const handleUpdate = (filters) => {
    // Save the checked types to restore them in mobile view
    if (filters && filters.types && filters.types.vals) {
      const checkedMap = {};
      filters.types.vals.forEach(type => {
        checkedMap[type.value] = type.checked;
      });
      setCheckedTypes(checkedMap);
    }
    
    setStockFilterState(filters)

    const filteredStock = allStock ? allStock.filter((item) => {
      if(findIndex(get(filters, 'brands.vals', []), {value: item.brand, checked: true}) !== -1 ) {
        return item;
      }
    })
    .filter((item) => {
      if(findIndex(get(filters, 'categories.vals', []), {value: item.category, checked: true}) !== -1) {
        return item;
      }
    })
    .filter((item) => {
      if(findIndex(get(filters, 'models', []), {value: item.name, checked: true}) !== -1) {
        return item;
      }
    })
    .filter((item) => {
      if(findIndex(get(filters, 'types.vals', []), {value: item.type, checked: true}) !== -1) {
        return item;
      }
    })
    .filter((item)=> {
      if(
        between(get(item, 'year', 0), get(filters, 'year.val[0]'), get(filters, 'year.val[1]'))
        || get(item, 'year', '').length === 0
      ) {
        return item;
      }
    })
    .filter((item)=> {
      if(
        between(get(item, 'price', 0), get(filters, 'price.val[0]'), get(filters, 'price.val[1]'))
      ) {
        return item;
      }
    }) : null

    sortItems(filteredStock);
  }

  const handleClearItem = (item) => {

    const newState = {
      ...filters,
      [item]: filters[item].map(item => {
        return {
          ...item,
          checked: false
        }
      })
    }

    handleUpdate(newState);
  }

  // Pagination
  const stockDisplay = stockItems ? stockItems.slice(start,end) : [];
  const paginationLength = stockItems ? Math.ceil(stockItems.length / numberPerPage) : 0;

  const handlePaginationChange = (event, value, scroll) => {
    setPage(value);
    setStart(value === 1 ? 0 : (value - 1) * numberPerPage);
    setEnd(paginationLength === value ? stockItems.length : value * numberPerPage);

    if (scroll !== false) {
      const { top } = containerRef.current.getBoundingClientRect();
      const position = top + window.pageYOffset
      position ? window.scrollTo({
        top: position,
        behavior: 'smooth'
      }) : containerRef.current.scrollIntoView({ behavior: 'smooth'});
    }
  }

  const handleStockCardClick = (e, id) => {
    e && e.preventDefault();
  
    if (id) {
      window.history.pushState({
        model: id
      }, undefined, `/stock?model=${id}`);
      const title = setModelTitle(null, id, true);
      handleRouteChange(`/stock?model=${id}`, title)
    } else {
      window.history.pushState({
      }, undefined, `/stock`);
      document.title = defaultPageTitle;
      handleRouteChange(`/stock`, defaultPageTitle);
    }

    window.scrollTo(0,0);
    setActiveModel(id);
  }

  const setModels = (data) => {
    location.reload();
  };

  const setCanonical = () => {
    const pageCanonical = document.querySelectorAll('link[rel="canonical"]');
    pageCanonical && window.staticly && pageCanonical[0] && pageCanonical[0].setAttribute("href", 'https://www.' + window.staticly.dealerData.website + window.location.pathname + window.location.search);
  }

  const handleRouteChange = (url, title) => {
    dlPush({
      event: 'pageview',
      appHost: window.location.host,
      appPagepath: url,
      appPagetitle: title || document.title,
      appUrl: window.location.origin + (window.location.pathname !== '/' ? window.location.pathname : '')
    });
    setCanonical();
  }

  const setModelTitle = (data, id, get) => {
    const stock = data ? data : allStock;
    const _id = id ? id : activeModel
    const activeModelData = stock.find(item => (item.id === _id));

    if (!activeModelData) {
      return
    }

    const title = `${activeModelData.make} ${activeModelData.name} | ${window.staticly.dealerData.name}`;

    document.title = title

    if (get) {
      return title
    }
  }

  useEffect(() => {
    setCanonical();
    window.addEventListener('popstate', setModels);
    return () => {
      window.removeEventListener('popstate', setModels);
    }
  }, [])

  // FIX: window.staticly reads moved to useEffect — no more render-time window access
  useEffect(() => {
    if (window.staticly?.data) {
      if (window.staticly.data.sort) {
        setSortByVal({
          value: window.staticly.data.sort
        });
      }
      if (typeof(window.staticly.data.displayFinancePrice) !== 'undefined') {
        setDisplayFinancePrice(window.staticly.data.displayFinancePrice === 'false' ? false : true);
      }
    }
  }, []);

  const containerRef = useRef();



  const assignedDomains = ['jayco.com.au']

  const breadcrumbs = {
    list: [
      {
        link: {
            title: 'Home',
            href: '/',
            target: '_self',
            assignedDomains
        },
        active: false
      },
      {
        link: {
            title: 'Stock',
            href: '/stock',
            target: '_self',
            assignedDomains
        },
        active: true
      }
    ]
  };

  const handleBcClick = (e, link) => {
    if (link.href === window.location.pathname) {
      handleStockCardClick(e, null);
    }
  }

  console.log('stockFilterData ', {stockFilterData, stockFilterState});

  return (
    <Wrapper ref={containerRef} bg={activeModel ? false : true}>
      {/* FIX: dangerouslySetInnerHTML is fine here — React skips hydration diffing on this node
          so Twig-injected <script> tags run before our useEffects read from window.staticly */}
      {/* <div dangerouslySetInnerHTML={{__html: windowData}}>
      </div> */}
      {error ? 
        <>
          <Grid container className={'hasPadding'} direction={'row'} wrap="wrap">
            <Grid size={12}>
              <Box px={2}>
                <TitleContainer>
                  <Text variant="h6" colour="charcoal" align="center" uppercase>{error}</Text>
                </TitleContainer>
              </Box>
            </Grid>
          </Grid>
        </>
      :
      <>
        {
        <div style={{display: loading ? 'none' : 'block'}}>
          {activeModel ?
            <>
              <StockItem
                key={activeModel}
                model={activeModel}
                allStock={allStock}
                onStockCardClick={handleStockCardClick}
                data={allStock.find(item => (item.id === activeModel))}
                calculatorModal={props.calculatorModal}
                dealerSuburbs={[]}
                breadcrumbs={breadcrumbs}
                onBreadcrumbClick={handleBcClick}
                displayFinancePrice={displayFinancePrice}
                />
            </>
          :
            <>

              {breadcrumbs && 
                <Topo>
                  <LeftPadding>
                    <Grid container className={'hasPadding'} direction={'row'} wrap="wrap">
                      <Grid size={12}>
                        <Box px={2}>
                          <BreadcrumbsContainer>
                            <Breadcrumbs items={breadcrumbs}/>
                          </BreadcrumbsContainer>
                        </Box>
                      </Grid>
                    </Grid>
                  </LeftPadding>
                </Topo>
              }

              <div>
                <ContentBuilder 
                  dealerCb={true}
                />
              </div>
              <LeftPadding>
                <Grid container alignItems={'flex-start'} className={'hasPadding'} direction={'row'} wrap="wrap">
                  {theme.isWidthUp('lg', props.width) && stockFilterData &&
                    <Grid
                      size={{
                        xs: 12,
                        lg: 3
                      }}>
                      <Box px={2}>
                        <StockFilter
                          filterItems={stockFilterData}
                          state={stockFilterState}
                          onUpdate={handleUpdate}
                          onClearItem={handleClearItem}
                          defaultFilters={defaultFilters}
                        />
                      </Box>
                    </Grid>
                  }
                  {!theme.isWidthUp('lg', props.width) && stockFilterData &&
                    <>
                      <GridItem size={12}>
                        <Box px={2}>
                          <FilterBtn inline onClick={() => setDrawer(true)}>
                          <ReactSVG src={filter} />
                          <span>Filter and Search</span></FilterBtn>
                        </Box>
                      </GridItem>


                      {/* Mobile drawer */}
                      <ThemeProvider theme={customTheme}>
                        <SwipeableDrawer
                          anchor="right"
                          open={drawer}
                          onClose={() => setDrawer(false)}
                          onOpen={() => setDrawer(true)}
                          keepMounted={true}
                          ModalProps={{
                            keepMounted: true, // <-- keeps it in DOM
                          }}
                        >
                          <ThemeProvider theme={theme}>
                            <FilterContainer>
                              <CloseContainer>
                                <Icon onClick={() => setDrawer(false)} skyBlue>
                                  <ReactSVG src={close} />
                                </Icon>
                              </CloseContainer>
                              <Filters>
                                <Box px={2}>
                                  <StockFilter
                                    filterItems={stockFilterData}
                                    onUpdate={handleUpdate}
                                    state={stockFilterState}
                                    defaultFilters={defaultFilters}
                                  />
                                  <Buttons>
                                    <Cta inline onClick={() => setDrawer(false)}>Search</Cta>
                                    <Cta inline outline onClick={() => setDrawer(false)}>Cancel</Cta>
                                  </Buttons>
                                </Box>
                              </Filters>
                            </FilterContainer>
                          </ThemeProvider>
                        </SwipeableDrawer>
                      </ThemeProvider>
                    </>
                  }
                  <GridItem size={{xs: 12, lg: 9}}>
                    <Box px={theme.isWidthUp('lg', props.width) ? 2 : 0}>
                      <GreyWrapper>

                        <GreyBg>
                          <Box px={theme.isWidthUp('md', props.width) ? 4 : 2}>                      
                            {get(props, 'meta.title', null) && !activeModel &&
                              <TitleContainer>
                                <Text variant="h2" element={"h1"} colour="charcoal" uppercase>{title}</Text>
                              </TitleContainer>
                            }
                            <Display>
                              <DisplayDropdown>
                                <Dropdown
                                  options={[{
                                      value: 'name',
                                      text: 'Product name (A-Z)'
                                    },{
                                      value: 'low',
                                      text: 'Sort by price (low to high)'
                                    },{
                                      value: 'high',
                                      text: 'Sort by price (high to low)'
                                    }
                                  ]}
                                  value={sortByVal}
                                  onChange={(e) => setSortByVal(e)}
                                />
                              </DisplayDropdown>
                              <DisplayItems>
                                <Text variant="body1" colour={'black'} align="center"> Displaying {stockDisplay ? stockDisplay.length : 0} of {allStock ? allStock.length : 0}</Text>
                              </DisplayItems>
                            </Display>
                          </Box>
                          <Box px={theme.isWidthUp('lg', props.width) ? 2 : 1} py={4}>
                            {stockItems.length === 0 &&
                              <Grid container direction={'row'}>
                                <Grid size={12}>
                                  <Box px={2}>
                                    <Text variant="body1" colour="black">No stock. Please refine your search.</Text>
                                  </Box>
                                </Grid>
                              </Grid>
                            } 
                            <Grid container direction={'row'} alignItems={'stretch'}>
    
                                {stockItems && stockItems.slice(start,end).map(item => (
                                  <Grid
                                    key={item.id}
                                    size={{
                                      xs: 12,
                                      sm: 6,
                                      lg: 4
                                    }}>
                                    <CaravanCardWrapper px={theme.isWidthUp('lg', props.width) ? 2 : 1}>
                                      <CaravanCardContainer>
                                        <StockCard
                                          {...item}
                                          onClick={handleStockCardClick}
                                          price={item.price ? `$${toPrice(item.price)}` : null}
                                          weeklyRepayment={displayFinancePrice ? item.weeklyRepayment : null}
                                        />
                                      </CaravanCardContainer>
                                    </CaravanCardWrapper>
                                  </Grid>

                                ))}

                              {paginationLength > 1 &&
                                <Grid size={12}>
                                  <PaginationContainer>
                                    <Pagination
                                      page={page}
                                      onChange={handlePaginationChange}
                                      count={paginationLength}
                                    />
                                  </PaginationContainer>
                                </Grid>
                              }
                            </Grid>
                          </Box>
                        </GreyBg>
                      </GreyWrapper>
                    </Box>
                  </GridItem>
                </Grid>
              </LeftPadding>
            </>
          }
        </div>
        }
        {loading &&
        <>
         <Grid container className={'hasPadding'} direction={'row'} wrap="wrap">
           <Grid size={12}>
             <Box px={2}>
               <Loader />
             </Box>
           </Grid>
         </Grid>
        </>
        }
      </>}
    </Wrapper>
  );
}

StockContainer.propTypes = {

}

export default StockContainer